import formatAddress from './formatAddress';
import formatCurrency from './formatCurrency';
import formatDate from './formatDate';
import formatName from './formatName';
import getFormatters from './getFormatters';
import init from './init';
const formatAddressWithFormatters = formatAddress(getFormatters);
const formatCurrencyWithFormatters = formatCurrency(getFormatters);
const formatDateWithFormatters = formatDate(getFormatters);
const formatNameWithFormatters = formatName(getFormatters);
export { init, formatAddressWithFormatters as formatAddress, formatCurrencyWithFormatters as formatCurrency, formatDateWithFormatters as formatDate, formatNameWithFormatters as formatName, getFormatters, };
//# sourceMappingURL=index.js.map